import IconLaneSupport from './IconLaneSupport';

export default IconLaneSupport;